import React, { } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { Row, Col } from '@lockerpm/design';

import { } from "@ant-design/icons";

import commonComponents from "../../../components/common";

import General from "./components/information/General";
import DangerZone from "./components/information/DangerZone";

const Information = () => {
  const { PageHeader } = commonComponents;
  const { t } = useTranslation();
  const selectedProject = useSelector((state) => state.project.selectedProject);
  
  return (
    <div className="information layout-content">
      <PageHeader
        title={t('project_info.title')}
        subtitle={t('project_info.description')}
        actions={[]}
      />
      <Row gutter={[12, 12]}>
        <Col xl={24} md={24}>
          <General
            className={'mt-6'}
            project={selectedProject}
          />
          <DangerZone
            className={'mt-4'}
            project={selectedProject}
          />
        </Col>
      </Row>
    </div>
  );
}

export default Information;